const React = require("react");
const T = React.PropTypes;

require("./Task.less"); 

const Task = React.createClass({
    propTypes: { 
        Task: T.string.isRequired, 
        OnChange: T.func.isRequired
    }, 
    getInitialState() { 
        return {
            ShowTaskField: this.props.Task !== ""
        }
    }, 
    render() {
        return (<footer>
                <div>
                    {!this.state.ShowTaskField &&
                    (<div className="cs-ShowTask">Would you like to create a Task?
                        <button type="button" className="btn btn-warning cs-ShowTask__Button" onClick={this.showTaskField}>Create a Task</button>
                    </div>)} 
                </div>
                <div>
                    {this.state.ShowTaskField && (
                        <div className="cs-Task">
                            <label>Task:</label>
                            <textarea className="form-control" onChange={this.props.OnChange}
                                        value={this.props.Task}></textarea>
                        </div>
                    )}
                </div>
                </footer>)
    },

    showTaskField() {
        this.setState({
            ShowTaskField: true
        }); 
    }
});

module.exports = Task; 


// WEBPACK FOOTER //
// ./src/components/Task/Task.jsx